module.exports = __webpack_public_path__ + "static/FAQ-mobile-img-65fe3fe0cafb294886587699d842443c.png";